// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* =====================================
   OVERLAY
===================================== */

.admin-reject-overlay {
    position: fixed;
    inset: 0;
  
    z-index: 5000;
  
    display: flex;
    align-items: center;
    justify-content: center;
  
    padding: 20px;
  
    background:
      rgba(15, 23, 42, 0.55);
  
    box-sizing: border-box;
  
    overflow-y: auto;
  }
  
  
  /* =====================================
     MODAL
  ===================================== */
  
  .admin-reject-modal {
    width: 100%;
    max-width: 500px;
  
    max-height:
      calc(100dvh - 40px);
  
    padding: 26px;
  
    background: #ffffff;
  
    border-radius: 16px;
  
    box-shadow:
      0 24px 60px
      rgba(15, 23, 42, 0.22);
  
    box-sizing: border-box;
  
    overflow-y: auto;
  }
  
  
  .admin-reject-modal h2 {
    margin: 0;
  
    font-size: 21px;
    font-weight: 700;
  
    color: #101828;
  }
  
  
  .admin-reject-modal p {
    margin:
      10px 0 22px;
  
    font-size: 14px;
    line-height: 1.6;
  
    color: #667085;
  }
  
  
  .admin-reject-modal label {
    display: block;
  
    margin-bottom: 8px;
  
    font-size: 13px;
    font-weight: 600;
  
    color: #344054;
  }
  
  
  .admin-reject-modal textarea {
    width: 100%;
  
    min-height: 120px;
  
    padding:
      12px 14px;
  
    border:
      1px solid #d0d5dd;
  
    border-radius: 10px;
  
    box-sizing: border-box;
  
    resize: vertical;
  
    font-family: inherit;
    font-size: 16px;
  
    color: #101828;
  
    outline: none;
  }
  
  
  .admin-reject-modal textarea:focus {
    border-color: #f04438;
  
    box-shadow:
      0 0 0 3px
      rgba(240, 68, 56, 0.12);
  }
  
  
  /* =====================================
     ACTIONS
  ===================================== */
  
  .admin-reject-modal-actions {
    display: flex;
    justify-content: flex-end;
  
    gap: 10px;
  
    margin-top: 22px;
  }
  
  
  .admin-reject-cancel,
  .admin-reject-confirm {
    min-height: 42px;
  
    padding:
      10px 15px;
  
    border-radius: 9px;
  
    font-size: 14px;
    font-weight: 600;
  
    cursor: pointer;
  }
  
  
  .admin-reject-cancel {
    border:
      1px solid #d0d5dd;
  
    background: #ffffff;
  
    color: #344054;
  }
  
  
  .admin-reject-confirm {
    border:
      1px solid #d92d20;
  
    background: #d92d20;
  
    color: #ffffff;
  }
  
  
  .admin-reject-confirm:hover {
    background: #b42318;
  }
  
  
  .admin-reject-cancel:disabled,
  .admin-reject-confirm:disabled {
    opacity: 0.6;
  
    cursor: not-allowed;
  }
  
  
  /* =====================================
     MOBILE
  ===================================== */
  
  @media (max-width: 600px) {
  
    .admin-reject-overlay {
      align-items: flex-end;
  
      padding: 0;
    }
  
  
    .admin-reject-modal {
      max-width: none;
  
      max-height: 90dvh;
  
      padding:
        22px 18px
        calc(
          18px +
          env(safe-area-inset-bottom)
        );
  
      border-radius:
        20px 20px 0 0;
    }
  
  
    .admin-reject-modal h2 {
      font-size: 19px;
    }
  
  
    .admin-reject-modal-actions {
      flex-direction: column-reverse;
    }
  
  
    .admin-reject-cancel,
    .admin-reject-confirm {
      width: 100%;
  
      min-height: 46px;
    }
  
  }`, "",{"version":3,"sources":["webpack://./src/admin/styles/AdminRejectModal.css"],"names":[],"mappings":"AAAA;;uCAEuC;;AAEvC;IACI,eAAe;IACf,QAAQ;;IAER,aAAa;;IAEb,aAAa;IACb,mBAAmB;IACnB,uBAAuB;;IAEvB,aAAa;;IAEb;4BACwB;;IAExB,sBAAsB;;IAEtB,gBAAgB;EAClB;;;EAGA;;yCAEuC;;EAEvC;IACE,WAAW;IACX,gBAAgB;;IAEhB;yBACqB;;IAErB,aAAa;;IAEb,mBAAmB;;IAEnB,mBAAmB;;IAEnB;;4BAEwB;;IAExB,sBAAsB;;IAEtB,gBAAgB;EAClB;;;EAGA;IACE,SAAS;;IAET,eAAe;IACf,gBAAgB;;IAEhB,cAAc;EAChB;;;EAGA;IACE;iBACa;;IAEb,eAAe;IACf,gBAAgB;;IAEhB,cAAc;EAChB;;;EAGA;IACE,cAAc;;IAEd,kBAAkB;;IAElB,eAAe;IACf,gBAAgB;;IAEhB,cAAc;EAChB;;;EAGA;IACE,WAAW;;IAEX,iBAAiB;;IAEjB;eACW;;IAEX;uBACmB;;IAEnB,mBAAmB;;IAEnB,sBAAsB;;IAEtB,gBAAgB;;IAEhB,oBAAoB;IACpB,eAAe;;IAEf,cAAc;;IAEd,aAAa;EACf;;;EAGA;IACE,qBAAqB;;IAErB;;6BAEyB;EAC3B;;;EAGA;;yCAEuC;;EAEvC;IACE,aAAa;IACb,yBAAyB;;IAEzB,SAAS;;IAET,gBAAgB;EAClB;;;EAGA;;IAEE,gBAAgB;;IAEhB;eACW;;IAEX,kBAAkB;;IAElB,eAAe;IACf,gBAAgB;;IAEhB,eAAe;EACjB;;;EAGA;IACE;uBACmB;;IAEnB,mBAAmB;;IAEnB,cAAc;EAChB;;;EAGA;IACE;uBACmB;;IAEnB,mBAAmB;;IAEnB,cAAc;EAChB;;;EAGA;IACE,mBAAmB;EACrB;;;EAGA;;IAEE,YAAY;;IAEZ,mBAAmB;EACrB;;;EAGA;;yCAEuC;;EAEvC;;IAEE;MACE,qBAAqB;;MAErB,UAAU;IACZ;;;IAGA;MACE,eAAe;;MAEf,iBAAiB;;MAEjB;;;;;SAKG;;MAEH;qBACe;IACjB;;;IAGA;MACE,eAAe;IACjB;;;IAGA;MACE,8BAA8B;IAChC;;;IAGA;;MAEE,WAAW;;MAEX,gBAAgB;IAClB;;EAEF","sourcesContent":["/* =====================================\n   OVERLAY\n===================================== */\n\n.admin-reject-overlay {\n    position: fixed;\n    inset: 0;\n  \n    z-index: 5000;\n  \n    display: flex;\n    align-items: center;\n    justify-content: center;\n  \n    padding: 20px;\n  \n    background:\n      rgba(15, 23, 42, 0.55);\n  \n    box-sizing: border-box;\n  \n    overflow-y: auto;\n  }\n  \n  \n  /* =====================================\n     MODAL\n  ===================================== */\n  \n  .admin-reject-modal {\n    width: 100%;\n    max-width: 500px;\n  \n    max-height:\n      calc(100dvh - 40px);\n  \n    padding: 26px;\n  \n    background: #ffffff;\n  \n    border-radius: 16px;\n  \n    box-shadow:\n      0 24px 60px\n      rgba(15, 23, 42, 0.22);\n  \n    box-sizing: border-box;\n  \n    overflow-y: auto;\n  }\n  \n  \n  .admin-reject-modal h2 {\n    margin: 0;\n  \n    font-size: 21px;\n    font-weight: 700;\n  \n    color: #101828;\n  }\n  \n  \n  .admin-reject-modal p {\n    margin:\n      10px 0 22px;\n  \n    font-size: 14px;\n    line-height: 1.6;\n  \n    color: #667085;\n  }\n  \n  \n  .admin-reject-modal label {\n    display: block;\n  \n    margin-bottom: 8px;\n  \n    font-size: 13px;\n    font-weight: 600;\n  \n    color: #344054;\n  }\n  \n  \n  .admin-reject-modal textarea {\n    width: 100%;\n  \n    min-height: 120px;\n  \n    padding:\n      12px 14px;\n  \n    border:\n      1px solid #d0d5dd;\n  \n    border-radius: 10px;\n  \n    box-sizing: border-box;\n  \n    resize: vertical;\n  \n    font-family: inherit;\n    font-size: 16px;\n  \n    color: #101828;\n  \n    outline: none;\n  }\n  \n  \n  .admin-reject-modal textarea:focus {\n    border-color: #f04438;\n  \n    box-shadow:\n      0 0 0 3px\n      rgba(240, 68, 56, 0.12);\n  }\n  \n  \n  /* =====================================\n     ACTIONS\n  ===================================== */\n  \n  .admin-reject-modal-actions {\n    display: flex;\n    justify-content: flex-end;\n  \n    gap: 10px;\n  \n    margin-top: 22px;\n  }\n  \n  \n  .admin-reject-cancel,\n  .admin-reject-confirm {\n    min-height: 42px;\n  \n    padding:\n      10px 15px;\n  \n    border-radius: 9px;\n  \n    font-size: 14px;\n    font-weight: 600;\n  \n    cursor: pointer;\n  }\n  \n  \n  .admin-reject-cancel {\n    border:\n      1px solid #d0d5dd;\n  \n    background: #ffffff;\n  \n    color: #344054;\n  }\n  \n  \n  .admin-reject-confirm {\n    border:\n      1px solid #d92d20;\n  \n    background: #d92d20;\n  \n    color: #ffffff;\n  }\n  \n  \n  .admin-reject-confirm:hover {\n    background: #b42318;\n  }\n  \n  \n  .admin-reject-cancel:disabled,\n  .admin-reject-confirm:disabled {\n    opacity: 0.6;\n  \n    cursor: not-allowed;\n  }\n  \n  \n  /* =====================================\n     MOBILE\n  ===================================== */\n  \n  @media (max-width: 600px) {\n  \n    .admin-reject-overlay {\n      align-items: flex-end;\n  \n      padding: 0;\n    }\n  \n  \n    .admin-reject-modal {\n      max-width: none;\n  \n      max-height: 90dvh;\n  \n      padding:\n        22px 18px\n        calc(\n          18px +\n          env(safe-area-inset-bottom)\n        );\n  \n      border-radius:\n        20px 20px 0 0;\n    }\n  \n  \n    .admin-reject-modal h2 {\n      font-size: 19px;\n    }\n  \n  \n    .admin-reject-modal-actions {\n      flex-direction: column-reverse;\n    }\n  \n  \n    .admin-reject-cancel,\n    .admin-reject-confirm {\n      width: 100%;\n  \n      min-height: 46px;\n    }\n  \n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
